import cogoToast from 'cogo-toast';
import { takeLatest, fork, put, all, call } from 'redux-saga/effects';

import { customHeaders, adminAPIURL } from '../../../../../Containers/Config/index.js';
import {
  SAVE_MANUAL_BOOKING_DRAFT,
  SAVE_MANUAL_BOOKING_DRAFT_SUCCESS,
  SAVE_MANUAL_BOOKING_DRAFT_ERROR,
} from '../../actions.js';
import apiCall from '../../../apiCall.js';

function* saveManualBookingDraft({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const isBookingModification = payload.issueType === 'booking_modification';
    const formData = new FormData();

    if (isBookingModification) {
      formData.append('booking_type_id', payload.bookingType);
      if (payload.file) formData.append('bulk-booking-modification-file', payload.file);
    } else {
      formData.append('booking-type', payload.bookingType);
      if (payload.file) formData.append('utility-request-attachments', payload.file);
      if (payload.remarks) formData.append('remarks', payload.remarks);
      if (payload.fileUrl) formData.append('file-url', payload.fileUrl);
    }

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v2/utility-request/${isBookingModification ? 'booking-modification' : 'manual-booking'}/draft`,
      method: 'POST',
      data: formData,
      isFormData: true,
      headers: filteredHeaders,
    });

    if (response.status === 200 || response.status === 201) {
      // No toast here — this call is the first leg of Submit for Approval, which toasts on completion.
      yield put({ type: SAVE_MANUAL_BOOKING_DRAFT_SUCCESS, payload: response?.data });
    } else {
      cogoToast.error(response?.response?.data?.message || 'Failed to save draft');
      yield put({ type: SAVE_MANUAL_BOOKING_DRAFT_ERROR, payload: response?.response?.data?.message });
    }
  } catch (error) {
    cogoToast.error('Failed to save draft');
    yield put({ type: SAVE_MANUAL_BOOKING_DRAFT_ERROR, payload: error });
  }
}

export function* watchSaveManualBookingDraft() {
  yield takeLatest(SAVE_MANUAL_BOOKING_DRAFT, saveManualBookingDraft);
}

function* saveManualBookingDraftSaga() {
  yield all([fork(watchSaveManualBookingDraft)]);
}

export default saveManualBookingDraftSaga;